import { Job } from "./job.model";
import { Membership } from "../membership/membership.model";
import { User } from "../user/user.model";
import { IAclFilterCustomCheck } from "../../store/queries/acl-filter-custom-check.interface";

export class JobAssigneeRestrictedAccountObjectAclFilterCustomCheck implements IAclFilterCustomCheck<Job> {

    hasAccess(item: Job, membership: Membership, user: User): boolean {
        return item.assigneeId === user.id;
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job/job-assignee.restricted-account-object-acl-filter-custom-check.ts